/* sm2-home.js: Inflate-O home page behaviour. Deferred, tiny, idempotent.
   "Get my $100 code" buttons (open the theme's email popup), the StressMap zone tour (pause / play,
   stops on focus or mouse, one pass then rests on the payoff, aria-pressed on the active step and marker),
   and an IntersectionObserver that pauses every CSS animation in a section that is off screen. The Affirm promo refresh
   is gone since 2026-10-30 (Harry): the Affirm line is a fixed sentence now, with no SDK to refresh.
   Re-runs for a section when the theme editor re-renders it (shopify:section:load). */
(function () {
  'use strict';
  if (window.SM2 && window.SM2.booted) { return; }
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var q = new URLSearchParams(location.search);

  /* ---- "Get my $100 code" buttons: the code is never printed on the page; every [data-smec-open] opens the theme's email popup
          (snippets/sm-email-capture.liquid, window.smecOpen), which subscribes the email and then shows the code. The snippet's own
          delegated listener handles [data-smec-open] too; show() guards against opening twice, so both firing is harmless. ---- */
  function initSmec() {
    if (initSmec.done) { return; }
    initSmec.done = true;
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('.sm2-sec [data-smec-open]') : null;
      if (!b) { return; }
      e.preventDefault();
      if (typeof window.smecOpen === 'function') { window.smecOpen(); }
    });
  }

  /* ---- StressMap zone tour ---- */
  function initZones(root) {
    root.querySelectorAll('.sm2-zone-card').forEach(function (card) {
      if (card.dataset.sm2) { return; }
      card.dataset.sm2 = '1';
      /* the bounce runs on the unit LAYER svg (an HTML level element the compositor handles), not on the SVG group inside it */
      var unit = card.querySelector('.sm2-svg--unit') || card.querySelector('.unit'), detail = card.querySelector('.sm2-zdetail'), prog = card.querySelector('.sm2-zprog');
      var result = card.querySelector('.sm2-zone-result'), rail = card.querySelector('.sm2-zsteps'), play = card.querySelector('.sm2-zplay');
      var seen = {};
      var steps = rail ? Array.prototype.slice.call(rail.querySelectorAll('.sm2-zs[data-zone]')).filter(function (s) {
        var z = s.getAttribute('data-zone'); if (seen[z]) { return false; } seen[z] = true; return true;
      }) : [];
      var order = steps.map(function (s) { return s.getAttribute('data-zone'); });
      if (!order.length) { return; }
      var i = 0, timer = null, touched = false, inView = true, first = true;
      var interval = parseInt(card.getAttribute('data-interval') || '3800', 10);
      var autoplay = card.getAttribute('data-autoplay') !== 'false';
      function setPlayUI(running) {
        /* is-playing drives the drawing's motion (bounce, shadow, drips, pulse ring): it moves only while the tour plays */
        card.classList.toggle('is-playing', !!running);
        if (!play) { return; }
        play.classList.toggle('is-paused', !running);
        play.setAttribute('aria-label', running ? (play.getAttribute('data-pause') || 'Pause the tour') : (play.getAttribute('data-play') || 'Play the tour'));
      }
      function restartProg() { if (!prog) { return; } prog.classList.remove('run'); void prog.offsetWidth; if (!touched && !reduce && autoplay) { prog.classList.add('run'); } }
      function boing() { if (reduce || !unit) { return; } unit.classList.remove('boing'); void unit.getBoundingClientRect(); unit.classList.add('boing'); }
      /* the one shot boing class comes off when it ends, so the tour's bounce can run again afterwards */
      if (unit) { unit.addEventListener('animationend', function (e) { if (e.animationName === 'sm2-boing') { unit.classList.remove('boing'); } }); }
      function setZone(z) {
        i = Math.max(0, order.indexOf(z));
        card.querySelectorAll('[data-zone]').forEach(function (el) {
          var dz = el.getAttribute('data-zone'), marker = el.classList.contains('hs') || el.classList.contains('sm2-ring');
          var on = (dz === z) || (z === 'all' && dz === 'light' && marker);
          el.classList.toggle('is-active', on);
          if (el.classList.contains('sm2-zs') || el.classList.contains('hs')) { el.setAttribute('aria-pressed', on ? 'true' : 'false'); }
        });
        card.querySelectorAll('.z').forEach(function (el) {
          var on = el.classList.contains('z-' + z) || (z === 'light' && el.classList.contains('z-light')) || (z === 'all');
          el.classList.toggle('is-active', on);
        });
        if (result) { result.classList.toggle('is-on', z === 'all'); }
        if (detail) {
          detail.setAttribute('aria-live', touched ? 'polite' : 'off');
          detail.classList.toggle('is-light', z === 'light'); detail.classList.toggle('is-pay', z === 'all');
        }
        var step = steps[i];
        if (rail && step && rail.scrollWidth > rail.clientWidth + 4) { var li = step.parentNode; rail.scrollTo({ left: li.offsetLeft - rail.clientWidth / 2 + li.offsetWidth / 2, behavior: (reduce || first) ? 'auto' : 'smooth' }); }
        first = false;
        if (z === 'all') { boing(); }
        restartProg();
      }
      function stop() { touched = true; if (timer) { clearInterval(timer); timer = null; } if (prog) { prog.classList.remove('run'); } setPlayUI(false); }
      function tick() { if (touched || !inView) { return; } var n = i + 1; if (n >= order.length) { stop(); return; } setZone(order[n]); }
      function start() { touched = false; if (i >= order.length - 1) { setZone(order[0]); } if (!timer) { timer = setInterval(tick, interval); } restartProg(); setPlayUI(true); }
      function stepBy(d) { stop(); setZone(order[(i + d + order.length) % order.length]); }
      card.querySelectorAll('[data-zone]').forEach(function (el) {
        var z = el.getAttribute('data-zone');
        if (order.indexOf(z) < 0 || el.classList.contains('sm2-zd') || el.classList.contains('sm2-ring')) { return; }
        el.addEventListener('mouseenter', function () { if (!('ontouchstart' in window) && !el.classList.contains('sm2-zs')) { stop(); setZone(z); } });
        el.addEventListener('click', function (e) { e.preventDefault(); stop(); setZone(z); if (el.classList.contains('hs')) { boing(); } });
        el.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); stop(); setZone(z); } });
      });
      var prev = card.querySelector('.sm2-zprev'), next = card.querySelector('.sm2-znext');
      if (prev) { prev.addEventListener('click', function () { stepBy(-1); }); }
      if (next) { next.addEventListener('click', function () { stepBy(1); }); }
      if (play) { play.addEventListener('click', function () { if (timer) { stop(); } else { start(); } }); }
      /* keyboard focus inside the card stops the tour (WCAG 2.2.2), except on the pause / play button itself: Chrome focuses a button
         on tap or click BEFORE the click fires, so a stop here made the first press of Pause restart the tour. Touch scrolling does not
         stop it. There is no card-level mouse stop: a pointer crossing the card on its way to the Pause button cannot be told from any
         other, so that stop could never be made immune; a mouse stops the tour when it reaches a zone (mouseenter above). */
      card.addEventListener('focusin', function (e) { if (play && play.contains(e.target)) { return; } if (timer) { stop(); } });
      var frozen = q.get('z');
      if (frozen && order.indexOf(frozen) > -1) { touched = true; setZone(frozen); setPlayUI(false); }
      else {
        setZone(order[0]);
        if (!reduce && autoplay) {
          timer = setInterval(tick, interval); setPlayUI(true);
          /* on entry the interval is restarted from zero so the first step seen (zone 1) gets the full interval, not the remainder of
             a phase that began while the card was off screen; the progress bar restarts with it */
          if ('IntersectionObserver' in window) { new IntersectionObserver(function (es) { inView = es[es.length - 1].isIntersecting; if (inView) { if (timer) { clearInterval(timer); timer = setInterval(tick, interval); } restartProg(); } }, { threshold: 0.2 }).observe(card); }
        } else { setPlayUI(false); }
      }
    });
  }

  /* ---- pause every CSS animation inside a section that is not on screen (hero clouds, sunbursts), and the StressMap drawing
          unless at least a quarter of the drawing itself is in view (a section's top 22px on screen used to run all of it) ---- */
  var io = null, ioStage = null;
  function initOffscreen(root) {
    if (!('IntersectionObserver' in window)) { return; }
    if (!io) { io = new IntersectionObserver(function (es) { es.forEach(function (e) { e.target.classList.toggle('is-offscreen', !e.isIntersecting); }); }, { rootMargin: '0px' }); }
    if (!ioStage) { ioStage = new IntersectionObserver(function (es) { es.forEach(function (e) { e.target.classList.toggle('is-offscreen', e.intersectionRatio < 0.25); }); }, { threshold: [0, 0.25, 0.5] }); }
    root.querySelectorAll('.sm2-sec').forEach(function (sec) { if (sec.dataset.sm2io) { return; } sec.dataset.sm2io = '1'; io.observe(sec); });
    root.querySelectorAll('.sm2-zstage').forEach(function (st) { if (st.dataset.sm2io) { return; } st.dataset.sm2io = '1'; ioStage.observe(st); });
  }

  function init(root) { initSmec(); initZones(root); initOffscreen(root); }

  window.SM2 = { booted: true, init: init };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { init(document); }); } else { init(document); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
